import { useAuthSession } from '../core/auth/useAuthSession'
import { LoginView } from '../core/auth/LoginView'
import { AuthenticatedApp } from './AuthenticatedApp'

export function App() {
  const { session, loading } = useAuthSession()
  if (loading) return <main className="center-screen">Avvio Event Platform…</main>
  return session ? <AuthenticatedApp /> : <LoginView />
}
